import styled from "styled-components"
import { colors } from "../colors/colors"
export const ProjectHeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 175px 1fr 200px;
  color: ${colors.white};
  justify-items: center;
  align-items: center;

  @media (max-width: 650px) {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-template-rows: 50px 50px;
  }

  @media (max-width: 812px) {
    padding: 0 0.5rem;
  }
`
